import * as React from 'react';
import { useAsyncDebounce } from 'react-table';

// Custom Controls
import BaseInputControl from './BaseInputControl';

// Types
import { ITextControlProps } from '@/@types/controls/controls';
import { HashMap } from './types';

function TextControl(props: ITextControlProps) {
  const { onChange, value, field } = props;

  const [localValue, setLocalValue] = React.useState<string>(value ?? '');

  React.useEffect(() => {
    setLocalValue(value ?? '');
  }, [value]);

  const debouncedOnChange = useAsyncDebounce((val: string) => {
    if (onChange) onChange(val, field.source);
  }, 150);

  const handleChange = (newValue: string, source: string) => {
    let isValueParsedAndSubmit = false;
    try {
      const tmp: HashMap = JSON.parse(newValue as string);
      isValueParsedAndSubmit = '#submit' in tmp && tmp['#submit'];
    } catch (_) {
      // do nothing and proceed
    }

    if (!isValueParsedAndSubmit) {
      setLocalValue(newValue);
    }

    debouncedOnChange(newValue);
  };

  return <BaseInputControl {...props} onChange={handleChange} value={localValue} />;
}
export default TextControl;
